// Mock data for Foam Sheet Suppliers website

export const company = {
  name: "Foam Sheet Suppliers",
  shortName: "FSS",
  domain: "foamsheetsuppliers.co.in",
  tagline: "Manufacturer, Supplier, Wholesaler & Trader of Foam Sheet Products",
  location: "Halol, Gujarat, India",
  workingHours: "Mon-Sat 9.00 AM to 6.00 PM",
  phone: "+91 80458 12817",
  phoneRaw: "08045812817",
  email: "info@foamsheetsuppliers.co.in",
  address: "Plot No. 142, GIDC Industrial Estate, Halol - 389350, Panchmahal, Gujarat, India",
  established: "2013",
  employees: "30+",
  productionUnits: "01",
  branches: "01"
};

export const heroSlides = [
  {
    id: 1,
    image: "https://images.pexels.com/photos/7227620/pexels-photo-7227620.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Premium Quality Foam Sheets",
    subtitle: "Manufacturer and Supplier",
    cta: "Explore Products"
  },
  {
    id: 2,
    image: "https://images.pexels.com/photos/7598137/pexels-photo-7598137.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Memory & PU Mattress Foam",
    subtitle: "Sleep Soft. Live Better.",
    cta: "View Catalog"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1727199079123-ba845d5ab4f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHx3YXJlaG91c2UlMjBmYWN0b3J5fGVufDB8fHx8MTc3NzE3NDY0MHww&ixlib=rb-4.1.0&q=85",
    title: "Wholesale Foam Sheet Distribution",
    subtitle: "Pan India Delivery & Bulk Orders",
    cta: "Get a Quote"
  }
];

export const featureCards = [
  {
    id: 1,
    title: "Pillared By Strong Team Work",
    description: "The growth rate that our company holds today is simply pillared with the strength of our strong team work.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Our Facilities",
    description: "We are acquiring a highly sophisticated production unit along with a spacious warehouse.",
    icon: "Factory"
  },
  {
    id: 3,
    title: "Company Profile",
    description: "Foam Sheet Suppliers deals in the production of highly qualitative range of foam sheet products.",
    icon: "Building2"
  }
];

export const reasons = [
  {
    id: 1,
    title: "100% Customer Satisfaction Guarantee",
    image: "https://images.pexels.com/photos/7709141/pexels-photo-7709141.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    title: "Premium Quality Products",
    image: "https://images.unsplash.com/photo-1599163666602-ef737d996c16"
  },
  {
    id: 3,
    title: "Best Packaging In Industry",
    image: "https://images.pexels.com/photos/18372333/pexels-photo-18372333.jpeg"
  },
  {
    id: 4,
    title: "Best Wholesale Pricing",
    image: "https://images.unsplash.com/photo-1605874562151-24fc26211285?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHx3YXJlaG91c2UlMjBmYWN0b3J5fGVufDB8fHx8MTc3NzE3NDY0MHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    title: "Dedicated Customer Service",
    image: "https://images.pexels.com/photos/8867630/pexels-photo-8867630.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 6,
    title: "Lowest Global Shipping Rates",
    image: "https://images.pexels.com/photos/15016516/pexels-photo-15016516.jpeg"
  }
];

export const products = [
  {
    id: "high-density-mattress-foam",
    name: "High Density Mattress Foam",
    image: "https://images.unsplash.com/photo-1699466983818-5438e380b453",
    price: "₹ 250 / Kilogram",
    minOrder: "500 Kilogram",
    description: "High-density mattress foam offers excellent durability, support, and longevity. Manufactured with premium polyurethane, it ensures consistent comfort and shape retention for years.",
    specs: { Density: "40 kg/m³", Thickness: "1-8 inch", Color: "White / Off-White", Hardness: "Medium-Firm", Application: "Mattress, Cushioning" },
    category: "Mattress Foam"
  },
  {
    id: "memory-mattress-foam",
    name: "Memory Mattress Foam",
    image: "https://images.unsplash.com/photo-1599163666602-ef737d996c16",
    price: "₹ 480 / Kilogram",
    minOrder: "200 Kilogram",
    description: "Visco-elastic memory foam that contours perfectly to body shape, providing ergonomic spinal support and pressure-point relief for premium sleep comfort.",
    specs: { Density: "55 kg/m³", Thickness: "1-4 inch", Color: "Blue / White", Hardness: "Soft", Application: "Premium Mattress, Pillows" },
    category: "Memory Foam"
  },
  {
    id: "comfortable-mattress-foam",
    name: "Comfortable Mattress Foam",
    image: "https://images.pexels.com/photos/10600090/pexels-photo-10600090.jpeg",
    price: "₹ 220 / Kilogram",
    minOrder: "500 Kilogram",
    description: "Soft, breathable comfort-grade foam designed for all-night relaxation. Ideal for everyday mattress use with balanced softness and resilience.",
    specs: { Density: "32 kg/m³", Thickness: "2-6 inch", Color: "White", Hardness: "Medium", Application: "Domestic Mattress" },
    category: "Mattress Foam"
  },
  {
    id: "mermaid-mattress-foam",
    name: "Mermaid Mattress Foam",
    image: "https://images.pexels.com/photos/10600087/pexels-photo-10600087.jpeg",
    price: "₹ 350 / Piece",
    minOrder: "50 Piece",
    description: "Premium quilted mattress finish with foam core. A complete solution for hospitality, household, and hostel bedding requirements.",
    specs: { Size: "72x36, 75x60, 78x72 inch", Thickness: "4-8 inch", Cover: "Knitted Fabric", Hardness: "Medium", Application: "Hospitality, Home" },
    category: "Finished Mattress"
  },
  {
    id: "flexible-mattress-foam",
    name: "Flexible Mattress Foam",
    image: "https://images.unsplash.com/photo-1632146175602-58736e7b27e4",
    price: "₹ 180 / Kilogram",
    minOrder: "500 Kilogram",
    description: "Multi-color flexible polyurethane foam sheets used in automotive, footwear, packaging and craft applications. Available in custom thicknesses.",
    specs: { Density: "20-28 kg/m³", Thickness: "4mm-50mm", Color: "Multi-Color", Hardness: "Soft", Application: "Industrial, Craft" },
    category: "PU Foam"
  },
  {
    id: "pu-mattress-foam",
    name: "PU Mattress Foam",
    image: "https://images.unsplash.com/photo-1741308478061-62ae87cdba16",
    price: "₹ 200 / Kilogram",
    minOrder: "500 Kilogram",
    description: "Standard polyurethane foam ideal for general purpose mattress and upholstery applications. Cost-effective with great resilience.",
    specs: { Density: "28-35 kg/m³", Thickness: "1-6 inch", Color: "White / Yellow", Hardness: "Medium", Application: "Mattress, Sofa" },
    category: "PU Foam"
  },
  {
    id: "polyurethane-mattress-foam",
    name: "Polyurethane Mattress Foam",
    image: "https://images.pexels.com/photos/35383621/pexels-photo-35383621.jpeg",
    price: "₹ 230 / Kilogram",
    minOrder: "300 Kilogram",
    description: "Premium polyurethane foam blocks suitable for cutting into mattresses, sofas, cushions, and industrial gaskets.",
    specs: { Density: "30-45 kg/m³", Thickness: "Custom", Color: "White", Hardness: "Medium-Firm", Application: "Mattress, Furniture" },
    category: "PU Foam"
  },
  {
    id: "lightweight-mattress-foam",
    name: "Lightweight Mattress Foam",
    image: "https://images.unsplash.com/photo-1584609913325-2c7b306a8833",
    price: "₹ 160 / Kilogram",
    minOrder: "500 Kilogram",
    description: "Lightweight, easy-to-handle foam grade suitable for budget mattresses, school hostels, and bulk institutional supply.",
    specs: { Density: "18-22 kg/m³", Thickness: "2-6 inch", Color: "White", Hardness: "Soft-Medium", Application: "Budget Mattress" },
    category: "Mattress Foam"
  },
  {
    id: "fr-mattress-foam",
    name: "FR Mattress Foam",
    image: "https://images.pexels.com/photos/6587323/pexels-photo-6587323.jpeg",
    price: "₹ 320 / Kilogram",
    minOrder: "300 Kilogram",
    description: "Fire Retardant (FR) mattress foam meeting BS5852 / IS standards. Mandatory for hotels, hospitals and public installations.",
    specs: { Density: "35-45 kg/m³", Thickness: "1-8 inch", Color: "White / Pink", Hardness: "Medium-Firm", Application: "Hotels, Hospitals" },
    category: "Specialty Foam"
  },
  {
    id: "epe-foam-sheet-roll",
    name: "EPE Foam Sheet Roll & Article",
    image: "https://images.unsplash.com/photo-1699466983818-5438e380b453",
    price: "₹ 95 / Kilogram",
    minOrder: "100 Kilogram",
    description: "Expanded Polyethylene (EPE) foam rolls and articles for protective packaging, thermal insulation and shock absorption.",
    specs: { Density: "20-50 kg/m³", Thickness: "1mm-50mm", Color: "White", Roll_Length: "50-200 mtr", Application: "Packaging, Insulation" },
    category: "EPE Foam"
  },
  {
    id: "high-density-pu-mattress-foam",
    name: "High Density PU Mattress Foam",
    image: "https://images.unsplash.com/photo-1632146175602-58736e7b27e4",
    price: "₹ 280 / Kilogram",
    minOrder: "300 Kilogram",
    description: "Heavy-duty PU foam for orthopaedic mattresses and long-life industrial cushioning. Premium load-bearing performance.",
    specs: { Density: "45-55 kg/m³", Thickness: "1-8 inch", Color: "White", Hardness: "Firm", Application: "Orthopaedic Mattress" },
    category: "PU Foam"
  },
  {
    id: "epe-foam-sheet",
    name: "EPE Foam Sheet",
    image: "https://images.pexels.com/photos/18372333/pexels-photo-18372333.jpeg",
    price: "₹ 90 / Kilogram",
    minOrder: "100 Kilogram",
    description: "Closed-cell EPE foam sheets with excellent cushioning, water resistance and chemical resistance for packaging.",
    specs: { Density: "25-35 kg/m³", Thickness: "2mm-30mm", Color: "White", Size: "Custom", Application: "Packaging, Lining" },
    category: "EPE Foam"
  },
  {
    id: "bonded-mattress-foam",
    name: "Bonded Mattress Foam",
    image: "https://images.unsplash.com/photo-1741308478061-62ae87cdba16",
    price: "₹ 140 / Kilogram",
    minOrder: "500 Kilogram",
    description: "Recycled bonded foam blocks (rebonded foam) - eco-friendly, ultra-firm support ideal for gym mats, carpet underlay and economy mattress base.",
    specs: { Density: "80-120 kg/m³", Thickness: "1-6 inch", Color: "Multi", Hardness: "Very Firm", Application: "Gym, Underlay" },
    category: "Specialty Foam"
  },
  {
    id: "flexi-star-light-mattress-foam",
    name: "Flexi Star Light Mattress Foam",
    image: "https://images.pexels.com/photos/10600090/pexels-photo-10600090.jpeg",
    price: "₹ 175 / Kilogram",
    minOrder: "300 Kilogram",
    description: "Star series lightweight mattress foam - balanced softness for medium-budget mattress brands.",
    specs: { Density: "24 kg/m³", Thickness: "4-6 inch", Color: "White", Hardness: "Medium-Soft", Application: "Mattress" },
    category: "Mattress Foam"
  },
  {
    id: "high-density-plain-mattress-foam",
    name: "High Density Plain Mattress Foam",
    image: "https://images.unsplash.com/photo-1584609913325-2c7b306a8833",
    price: "₹ 260 / Kilogram",
    minOrder: "300 Kilogram",
    description: "Plain non-quilted high-density foam sheets for OEM mattress manufacturers and re-cutting workshops.",
    specs: { Density: "40-50 kg/m³", Thickness: "1-8 inch", Color: "White", Hardness: "Firm", Application: "OEM Mattress" },
    category: "Mattress Foam"
  }
];

export const popularProducts = products.slice(0, 12);
export const hotProducts = [products[12], products[13], products[14]];
export const productCategories = [
  "All",
  "Mattress Foam",
  "Memory Foam",
  "PU Foam",
  "EPE Foam",
  "Specialty Foam",
  "Finished Mattress"
];
